/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassCapacityRow } from './ClassCapacityRow';
import {
    ClassCapacityRowFromJSON,
    ClassCapacityRowFromJSONTyped,
    ClassCapacityRowToJSON,
    ClassCapacityRowToJSONTyped,
} from './ClassCapacityRow';

/**
 * 
 * @export
 * @interface ClassCapacityWidgetData
 */
export interface ClassCapacityWidgetData {
    /**
     * 
     * @type {Array<ClassCapacityRow>}
     * @memberof ClassCapacityWidgetData
     */
    items: Array<ClassCapacityRow>;
}

/**
 * Check if a given object implements the ClassCapacityWidgetData interface.
 */
export function instanceOfClassCapacityWidgetData(value: object): value is ClassCapacityWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ClassCapacityWidgetDataFromJSON(json: any): ClassCapacityWidgetData {
    return ClassCapacityWidgetDataFromJSONTyped(json, false);
}

export function ClassCapacityWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassCapacityWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClassCapacityRowFromJSON)),
    };
}

export function ClassCapacityWidgetDataToJSON(json: any): ClassCapacityWidgetData {
    return ClassCapacityWidgetDataToJSONTyped(json, false);
}

export function ClassCapacityWidgetDataToJSONTyped(value?: ClassCapacityWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClassCapacityRowToJSON)),
    };
}

